import EventFiltersPanel from './EventFiltersPanel'
export default EventFiltersPanel